var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_14481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0077 18.9201C53.812 16.0419 51.3884 12.9346 49.486 11.953C51.0345 14.9893 51.9302 18.0348 52.2726 20.3071C52.2726 20.3071 52.2726 20.3232 52.2784 20.353C49.1665 12.5944 43.8887 9.46531 39.5788 2.65395C39.36 2.31034 39.1424 1.96674 38.9294 1.59908C38.8091 1.39178 38.7118 1.20394 38.627 1.02641C38.4484 0.682009 38.3104 0.318022 38.2158 -0.0582301C38.2166 -0.0760973 38.2107 -0.093606 38.1992 -0.107361C38.1878 -0.121117 38.1717 -0.130139 38.154 -0.132678C38.1371 -0.137252 38.1193 -0.137252 38.1024 -0.132678C38.0979 -0.130603 38.0936 -0.127905 38.0898 -0.12466C38.083 -0.12466 38.0761 -0.116643 38.0692 -0.114352L38.0807 -0.129242C31.1662 3.9207 28.8206 11.4124 28.6052 15.1611C25.8422 15.3501 23.2003 16.3675 21.0242 18.0806C20.7968 17.8883 20.5589 17.7086 20.3118 17.5423C19.6847 15.347 19.6582 13.0236 20.2351 10.8145C17.4072 12.103 15.2081 14.136 13.6092 15.9354H13.5966C12.5051 14.5529 12.5819 9.99332 12.6437 9.04154C12.6311 8.98198 11.8305 9.4573 11.7274 9.52945C10.7643 10.2166 9.86395 10.9877 9.03702 11.8339C8.09601 12.7879 7.23631 13.8189 6.46687 14.916C4.69662 17.4248 3.44119 20.2595 2.77313 23.2564C2.76053 23.316 2.74908 23.3778 2.73648 23.4385C2.68494 23.6802 2.49825 24.8931 2.46503 25.1565V25.2172C2.22165 26.4705 2.07007 27.7399 2.01147 29.0152V29.1561C2.01147 44.3571 14.3354 56.681 29.5364 56.681C43.1511 56.681 54.4545 46.7967 56.6685 33.8131C56.7143 33.4614 56.7521 33.1064 56.7933 32.7513C57.3408 28.0302 56.7326 23.0686 55.0077 18.9201ZM23.2817 40.4664C23.41 40.5271 23.5314 40.5946 23.6631 40.6542L23.6814 40.6657C23.5497 40.6015 23.4157 40.5351 23.2828 40.4664H23.2817ZM52.2807 20.3656V20.3392V20.369V20.3656Z",
    fill: "url(#paint0_linear_116_14481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0077 18.9201C53.812 16.0419 51.3884 12.9346 49.486 11.953C51.0345 14.9893 51.9302 18.0348 52.2726 20.3071V20.3633C54.8703 27.4049 53.4546 34.5655 51.4159 38.9408C48.2616 45.7098 40.6256 52.6483 28.6717 52.3104C15.7671 51.9439 4.39034 42.3562 2.26572 29.8089C1.8786 27.8286 2.26572 26.8242 2.46043 25.2172C2.22335 26.4554 2.13286 26.8139 2.01489 29.0152V29.1561C2.01489 44.3571 14.3388 56.681 29.5398 56.681C43.1545 56.681 54.4579 46.7967 56.6719 33.8131C56.7177 33.4614 56.7555 33.1064 56.7967 32.7513C57.3408 28.0302 56.7326 23.0686 55.0077 18.9201Z",
    fill: "url(#paint1_radial_116_14481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0077 18.9201C53.812 16.0419 51.3884 12.9346 49.486 11.953C51.0345 14.9893 51.9302 18.0348 52.2726 20.3071V20.3633C54.8703 27.4049 53.4546 34.5655 51.4159 38.9408C48.2616 45.7098 40.6256 52.6483 28.6717 52.3104C15.7671 51.9439 4.39034 42.3562 2.26572 29.8089C1.8786 27.8286 2.26572 26.8242 2.46043 25.2172C2.22335 26.4554 2.13286 26.8139 2.01489 29.0152V29.1561C2.01489 44.3571 14.3388 56.681 29.5398 56.681C43.1545 56.681 54.4579 46.7967 56.6719 33.8131C56.7177 33.4614 56.7555 33.1064 56.7967 32.7513C57.3408 28.0302 56.7326 23.0686 55.0077 18.9201Z",
    fill: "url(#paint2_radial_116_14481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6312 22.1546C41.6919 22.1969 41.7457 22.2393 41.803 22.2817C41.1122 21.0551 40.2515 19.9323 39.2466 18.9464C30.6908 10.3907 37.004 0.39415 38.068 -0.114383L38.0794 -0.129272C31.165 3.92067 28.8193 11.4124 28.604 15.1611C28.9247 15.1393 29.2443 15.1118 29.5707 15.1118C34.7305 15.1118 39.2248 17.95 41.6312 22.1546Z",
    fill: "url(#paint3_radial_116_14481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5879 23.8634C29.5433 24.5506 27.1243 26.91 26.2779 26.91C18.4506 26.91 17.1804 31.6449 17.1804 31.6449C17.524 35.633 20.3026 38.9167 23.6642 40.6542C23.8177 40.7332 23.9723 40.8042 24.1224 40.8752C24.3915 40.9898 24.6618 41.1043 24.931 41.2062C26.0838 41.6128 27.291 41.8445 28.5125 41.8934C42.2314 42.5371 44.8909 25.4898 34.9894 20.5396C37.524 20.0987 40.156 21.1192 41.6255 22.1511C39.2203 17.9466 34.7248 15.1084 29.565 15.1084C29.2386 15.1084 28.9191 15.1359 28.5984 15.1576C25.8373 15.3489 23.198 16.3675 21.0242 18.0806C21.4445 18.4368 21.9187 18.9109 22.9163 19.8936C24.7878 21.7399 29.5776 23.6401 29.5879 23.8634Z",
    fill: "url(#paint4_radial_116_14481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5879 23.8634C29.5433 24.5506 27.1243 26.91 26.2779 26.91C18.4506 26.91 17.1804 31.6449 17.1804 31.6449C17.524 35.633 20.3026 38.9167 23.6642 40.6542C23.8177 40.7332 23.9723 40.8042 24.1224 40.8752C24.3915 40.9898 24.6618 41.1043 24.931 41.2062C26.0838 41.6128 27.291 41.8445 28.5125 41.8934C42.2314 42.5371 44.8909 25.4898 34.9894 20.5396C37.524 20.0987 40.156 21.1192 41.6255 22.1511C39.2203 17.9466 34.7248 15.1084 29.565 15.1084C29.2386 15.1084 28.9191 15.1359 28.5984 15.1576C25.8373 15.3489 23.198 16.3675 21.0242 18.0806C21.4445 18.4368 21.9187 18.9109 22.9163 19.8936C24.7878 21.7399 29.5776 23.6401 29.5879 23.8634Z",
    fill: "url(#paint5_radial_116_14481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7449 17.1654C19.9682 17.3097 20.1515 17.4311 20.3175 17.5422C19.6904 15.3469 19.6639 13.0235 20.2408 10.8145C17.413 12.103 15.2139 14.136 13.615 15.9353C13.7444 15.9319 17.7371 15.8597 19.7449 17.1654Z",
    fill: "url(#paint6_radial_116_14481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2657 29.8089C4.39032 42.3561 15.767 51.9438 28.6808 52.3103C40.6348 52.6482 48.2662 45.7097 51.4251 38.9407C53.4638 34.5644 54.8794 27.4048 52.2818 20.3632V20.3105C52.2818 20.3174 52.2818 20.3266 52.2875 20.3564C53.2633 26.7325 50.0209 32.9093 44.9516 37.0864C44.9463 37.0981 44.9414 37.11 44.9367 37.1219C35.0581 45.1657 25.6055 41.9747 23.6917 40.6725C23.5588 40.6083 23.4248 40.5419 23.2919 40.4732C17.532 37.7244 15.1531 32.473 15.6628 27.9729C10.8008 27.9729 9.14236 23.8703 9.14236 23.8703C9.14236 23.8703 13.5084 20.7572 19.2626 23.4648C24.5919 25.9731 29.5971 23.8714 29.5971 23.8703C29.5868 23.6469 24.7969 21.7411 22.9289 19.9005C21.9313 18.9178 21.4571 18.4436 21.0368 18.0874C20.8093 17.8951 20.5715 17.7154 20.3244 17.5491C20.1606 17.4346 19.9808 17.32 19.7517 17.1723C17.7439 15.8666 13.7512 15.9388 13.6195 15.9422H13.6069C12.5154 14.5598 12.5921 10.0001 12.654 9.04836C12.6414 8.9888 11.8408 9.46412 11.7377 9.53628C10.7746 10.2234 9.87422 10.9946 9.04729 11.8407C8.10628 12.7948 7.24658 13.8257 6.47714 14.9228C4.70689 17.4316 3.45146 20.2663 2.7834 23.2632C2.76164 23.3159 1.78237 27.5915 2.2657 29.8089Z",
    fill: "url(#paint7_radial_116_14481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2468 18.9465C40.2517 19.9323 41.1124 21.0551 41.8032 22.2817C41.9463 22.3892 42.0839 22.5039 42.2155 22.6253C48.4553 28.3704 45.1911 36.5035 44.9426 37.0876C50.0119 32.9105 53.2543 26.7337 52.2785 20.3575C49.1666 12.5944 43.8888 9.46531 39.5789 2.65395C39.3601 2.31034 39.1425 1.96674 38.9295 1.59908C38.8092 1.39178 38.7119 1.20394 38.6271 1.02641C38.4485 0.682009 38.3105 0.318022 38.216 -0.0582301C38.2167 -0.0760973 38.2108 -0.093606 38.1994 -0.107361C38.1879 -0.121117 38.1718 -0.130139 38.1541 -0.132678C38.1372 -0.137252 38.1194 -0.137252 38.1026 -0.132678C38.098 -0.130603 38.0938 -0.127905 38.09 -0.12466C38.0831 -0.12466 38.0762 -0.116643 38.0693 -0.114352C37.0042 0.394181 30.691 10.3908 39.2468 18.9465Z",
    fill: "url(#paint8_radial_116_14481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2131 22.6196C42.0816 22.4982 41.944 22.3835 41.8008 22.276C41.7447 22.2336 41.6863 22.1912 41.629 22.1489C40.1595 21.118 37.5275 20.0964 34.9929 20.5374C44.8933 25.4875 42.2349 42.5348 28.516 41.8912C27.2945 41.8422 26.0873 41.6106 24.9345 41.204C24.6653 41.1032 24.395 40.9921 24.1259 40.873C23.9701 40.8019 23.8155 40.7309 23.6677 40.6519L23.6861 40.6634C25.5999 41.969 35.0525 45.16 44.9311 37.1128C44.9311 37.1128 44.9368 37.0979 44.9459 37.0773C45.191 36.5035 48.4553 28.3704 42.2131 22.6196Z",
    fill: "url(#paint9_radial_116_14481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1805 31.6449C17.1805 31.6449 18.4507 26.9101 26.278 26.9101C27.1244 26.9101 29.5433 24.5484 29.588 23.8635C29.6327 23.1785 24.5829 25.9663 19.2536 23.458C13.4994 20.7504 9.1333 23.8635 9.1333 23.8635C9.1333 23.8635 10.7918 27.9661 15.6537 27.9661C15.1441 32.4661 17.523 37.713 23.2829 40.4664C23.4112 40.5271 23.5326 40.5947 23.6643 40.6542C20.3027 38.9202 17.5275 35.633 17.1805 31.6449Z",
    fill: "url(#paint10_radial_116_14481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0077 18.9201C53.812 16.0419 51.3884 12.9346 49.486 11.953C51.0345 14.9893 51.9302 18.0348 52.2726 20.3071C52.2726 20.3071 52.2726 20.3232 52.2784 20.353C49.1665 12.5944 43.8887 9.46531 39.5788 2.65395C39.36 2.31034 39.1424 1.96674 38.9294 1.59908C38.8091 1.39178 38.7118 1.20394 38.627 1.02641C38.4484 0.682009 38.3104 0.318022 38.2158 -0.0582301C38.2166 -0.0760973 38.2107 -0.093606 38.1992 -0.107361C38.1878 -0.121117 38.1717 -0.130139 38.154 -0.132678C38.1371 -0.137252 38.1193 -0.137252 38.1024 -0.132678C38.0979 -0.130603 38.0936 -0.127905 38.0898 -0.12466C38.083 -0.12466 38.0761 -0.116643 38.0692 -0.114352L38.0807 -0.129242C31.1662 3.9207 28.8206 11.4124 28.6052 15.1611C28.9259 15.1394 29.2455 15.1119 29.5719 15.1119C34.7317 15.1119 39.226 17.95 41.6324 22.1546C40.1629 21.1238 37.5309 20.1021 34.9963 20.5431C44.8966 25.4933 42.2383 42.5406 28.5193 41.8969C27.2979 41.8479 26.0907 41.6163 24.9378 41.2097C24.6687 41.1089 24.3984 40.9978 24.1292 40.8787C23.9735 40.8077 23.8188 40.7367 23.6711 40.6576L23.6894 40.6691C23.5566 40.605 23.4226 40.5385 23.2897 40.4698C23.418 40.5305 23.5394 40.5981 23.6711 40.6576C20.3026 38.9202 17.5275 35.633 17.1804 31.6449C17.1804 31.6449 18.4506 26.9101 26.2779 26.9101C27.1243 26.9101 29.5433 24.5484 29.5879 23.8634C29.5776 23.6401 24.7878 21.7342 22.9197 19.8937C21.9222 18.911 21.448 18.4368 21.0276 18.0806C20.8002 17.8883 20.5624 17.7086 20.3152 17.5423C19.6881 15.347 19.6616 13.0236 20.2385 10.8145C17.4106 12.103 15.2116 14.136 13.6127 15.9354H13.6001C12.5086 14.5529 12.5853 9.99332 12.6471 9.04154C12.6345 8.98198 11.834 9.4573 11.7309 9.52945C10.7677 10.2166 9.86738 10.9877 9.04046 11.8339C8.09945 12.7879 7.23974 13.8189 6.4703 14.916C4.70006 17.4248 3.44462 20.2595 2.77657 23.2564C2.76397 23.316 2.75251 23.3778 2.73991 23.4385C2.68837 23.6802 2.45472 24.9103 2.42265 25.1737C2.42265 25.1542 2.42265 25.1943 2.42265 25.1737C2.2082 26.4447 2.07089 27.7276 2.01147 29.0152V29.1561C2.01147 44.3571 14.3354 56.681 29.5364 56.681C43.1511 56.681 54.4545 46.7967 56.6685 33.8131C56.7143 33.4614 56.7521 33.1064 56.7933 32.7513C57.3408 28.0302 56.7326 23.0686 55.0077 18.9201Z",
    fill: "url(#paint11_linear_116_14481)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_116_14481",
    x1: 51.3644,
    y1: 8.66586,
    x2: 5.6697,
    y2: 52.7525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_116_14481",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.2524 6.17016) scale(57.3829 57.3829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_116_14481",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.2845 29.6291) scale(57.3829 57.3829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DB293D",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F5334B",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_116_14481",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2035 -6.85245) scale(41.5714 41.5714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_116_14481",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9382 44.6182) scale(27.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_116_14481",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1086 22.8093) rotate(-13.8972) scale(14.4755 17.0052)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8C4FF3",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_116_14481",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5596 3.82212) scale(19.6564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_116_14481",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.0102 -8.64492) scale(83.8633)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_116_14481",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.904 0.517765) rotate(84.2321) scale(61.128 40.1614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_116_14481",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0969 11.102) scale(52.356)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_116_14481",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.9178 14.167) scale(57.3039 57.3039)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_116_14481",
    x1: 50.8146,
    y1: 8.42992,
    x2: 11.9347,
    y2: 47.3109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FFF44F",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFF44F",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_14481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.6417,
    height: 58.6417,
    fill: "white",
    transform: "translate(0.178955 -0.136108)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.fa93b2a0d49f9bd5380a87596bb4fd26.svg";
export { ForwardRef as ReactComponent };